export default class UserWithoutGroupsException extends Error {
    constructor(message) {
        super(message);
        this.code = "UserWithoutGroupsException";
    }
}